import { Avatar, Button, Flex, List, Typography } from 'antd';
import type { ButtonProps } from 'antd';
import styled from 'styled-components';

import { PlusCircleOutlined } from '@ant-design/icons';

export const ListStyled = styled(List)`
  .ant-list-item {
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 16px 24px;
  }

  .ant-switch {
    margin: auto 0;
  }
` as typeof List;

export const Wrapper = styled(Flex).attrs({
  vertical: true,
  gap: 20,
  flex: 1,
})``;

export const StyledAvatar = styled(Avatar)<{ $program?: string }>`
  margin: auto 0;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  background-color: ${({ theme, $program }) => ($program ? theme.colorPrimary : theme.colorIcon)};
`;

export const ButtonWrapper = styled(Flex).attrs<{ $isDesktop: boolean }>(({ $isDesktop }) => ({
  align: 'center',
  flex: 1,
  justify: $isDesktop ? 'end' : 'start',
}))``;

export const AddButton = styled(Button).attrs(
  (): Pick<ButtonProps, 'type' | 'icon'> => ({
    type: 'primary',
    icon: <PlusCircleOutlined />,
  }),
)``;

interface ListItemProps {
  $isEnabled: boolean;
}

export const ListItem = styled(List.Item)<ListItemProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border: ${({ theme, $isEnabled }) => `1px solid ${$isEnabled ? theme.colorPrimaryBorder : theme.colorBorder}`};
  border-block-end: ${({ theme, $isEnabled }) =>
    `1px solid ${$isEnabled ? theme.colorPrimaryBorder : theme.colorBorder} !important`};
  background-color: ${({ theme, $isEnabled }) => ($isEnabled ? theme.colorPrimaryBg : theme.colorBgContainer)};
`;

export const ListItemContent = styled(Flex).attrs({
  flex: 1,
  gap: 16,
})`
  max-width: calc(100% - 60px);
  overflow: hidden;
`;

export const DetailsWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const StyledTitle = styled(Typography.Text).attrs({
  ellipsis: {
    tooltip: true,
  },
  style: {
    width: '100%',
    display: 'inline-block',
  },
})`
  color: ${({ theme }) => theme.colorText};
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 0;
  display: block;
`;

export const StyledDescription = styled(Typography.Text).attrs({
  ellipsis: {
    tooltip: true,
  },
  style: {
    display: 'inline-block',
  },
})<{ $pathSegment: string; $isMobile: boolean }>`
  color: ${({ theme, $pathSegment }) => ($pathSegment ? theme.colorPrimary : theme.colorTextDescription)};
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  display: block;
  width: ${({ $isMobile }) => ($isMobile ? '150px' : 'auto')};
`;
